import { jsx as r } from "react/jsx-runtime";
import { Tabs as e } from "@base-ui/react/tabs";
import { cva as o } from "class-variance-authority";
import { cn as i } from "../../lib/utils.js";
function p({
  className: t,
  orientation: a = "horizontal",
  ...n
}) {
  return /* @__PURE__ */ r(
    e.Root,
    {
      "data-slot": "tabs",
      "data-orientation": a,
      className: i(
        "group/tabs flex gap-2 data-horizontal:flex-col",
        t
      ),
      ...n
    }
  );
}
const s = o(
  "group/tabs-list inline-flex w-fit items-center justify-center rounded-lg p-[3px] text-muted-foreground group-data-horizontal/tabs:h-8 group-data-vertical/tabs:h-fit group-data-vertical/tabs:flex-col data-[variant=line]:rounded-none",
  {
    variants: {
      variant: {
        default: "bg-muted",
        line: "gap-1 bg-transparent"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function g({
  className: t,
  variant: a = "default",
  ...n
}) {
  return /* @__PURE__ */ r(
    e.List,
    {
      "data-slot": "tabs-list",
      "data-variant": a,
      className: i(s({ variant: a }), t),
      ...n
    }
  );
}
function c({ className: t, ...a }) {
  return /* @__PURE__ */ r(
    e.Tab,
    {
      "data-slot": "tabs-trigger",
      className: i(
        "relative inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-1.5 py-0.5 text-sm font-medium whitespace-nowrap text-foreground/60 transition-all group-data-vertical/tabs:w-full group-data-vertical/tabs:justify-start hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 has-data-[icon=inline-end]:pr-1 has-data-[icon=inline-start]:pl-1 aria-disabled:pointer-events-none aria-disabled:opacity-50 dark:text-muted-foreground dark:hover:text-foreground group-data-[variant=default]/tabs-list:data-active:shadow-sm group-data-[variant=line]/tabs-list:data-active:shadow-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        "group-data-[variant=line]/tabs-list:bg-transparent group-data-[variant=line]/tabs-list:data-active:bg-transparent dark:group-data-[variant=line]/tabs-list:data-active:border-transparent dark:group-data-[variant=line]/tabs-list:data-active:bg-transparent",
        "data-active:bg-background data-active:text-foreground dark:data-active:border-input dark:data-active:bg-input/30 dark:data-active:text-foreground",
        "after:absolute after:bg-foreground after:opacity-0 after:transition-opacity group-data-horizontal/tabs:after:inset-x-0 group-data-horizontal/tabs:after:bottom-[-5px] group-data-horizontal/tabs:after:h-0.5 group-data-vertical/tabs:after:inset-y-0 group-data-vertical/tabs:after:-right-1 group-data-vertical/tabs:after:w-0.5 group-data-[variant=line]/tabs-list:data-active:after:opacity-100",
        t
      ),
      ...a
    }
  );
}
function f({ className: t, ...a }) {
  return /* @__PURE__ */ r(
    e.Panel,
    {
      "data-slot": "tabs-content",
      className: i("flex-1 text-sm outline-none", t),
      ...a
    }
  );
}
export {
  p as Tabs,
  f as TabsContent,
  g as TabsList,
  c as TabsTrigger,
  s as tabsListVariants
};
//# sourceMappingURL=tabs.js.map
